import type { AllRouteEndpoints } from "../routeTypes";

export const companiesCompanyIdOauthMcpSettingsMarketplaceClientsKeyCacheKeys: AllRouteEndpoints[] = [
  "/companies/:company_id/oauth_mcp_settings/marketplace_clients",
  "/companies/:company_id/oauth_mcp_settings",
];
